/* eslint-disable default-case */
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import get from 'lodash/get';
import MessageBox from 'yoda-core-components/lib/components/MessageBox';
import {
    isRevieveBannerIRIS,
    isRevieveBannerCM,
} from 'yoda-core-components/lib/helpers/Utils/Utils';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import isEmpty from 'lodash/isEmpty';
import Loading from '../Loading/Loading';
import RevieveMessageBox from '../RevieveMessageBox/RevieveMessageBox';
import { addRevieveItemsToCart } from '../../helpers/Revieve/RevieveBannerHelper';
import { selectFeatureFlags, selectPreferences } from '../../selectors/ContextSelector';
import analyticsActions from '../../actions/AnalyticsAction';
import actions from '../../actions/AddToCartAction';

let skinCareUrlEvent = false;
let vtoUrlEvent = false;
let haircareUrlEvent = false;

const RevieveModal = (props) => {
    const componentToBeRendered = get(props, 'componentToBeRendered', {});
    const [isRevieveBanner, setIsRevieveBanner] = useState(false);
    const [analyticsPayload, setAnalyticsPayload] = useState([]);
    const [partnerID, setPartnerID] = useState('');
    const [isIE11, setIsIE11] = useState(false);
    const featureFlags = useSelector((state) => selectFeatureFlags(state));
    const preferences = useSelector((state) => selectPreferences(state));
    const [isSkinCareModal, setIsSkinCareModal] = useState(false);
    const [isVirtualTryOnModal, setIsVirtualTryOnModal] = useState(false);
    const [isHairCareModal, setIsHairCareModal] = useState(false);
    const analyticsId = get(props, 'data', '');
    const location = !__SERVER__ && window.location.href;
    const locationSrcOpen = location && location.split('srcopen=');
    const isSrcOpen = locationSrcOpen && locationSrcOpen.length > 0 && locationSrcOpen[1];
    const isCoremedia = get(props, 'isCoremedia', false);
    const unsupportedBrowserMessage = get(
        preferences,
        'revieveConfiguration.unsupportedBrowserMessage',
        ''
    );
    const dispatch = useDispatch();
    const { enableRevieveModal = true } = featureFlags;
    const { isRevieve, revieveAnalyticsID } = isCoremedia
        ? isRevieveBannerCM(analyticsId)
        : isRevieveBannerIRIS(analyticsId);
    const revieveBannerModal = () => {
        const {
            revieveConfiguration: {
                skinCareKey = '',
                nonPdpVirtualTryOnKey = '',
                hairCareKey = '',
            } = {},
        } = preferences;
        const { triggerSkinCareModal, triggerVTOModal, triggerHairCareModal } = analyticsActions;
        const extractedWord = isSrcOpen && isSrcOpen.split('-')[0];

        setIsRevieveBanner(isRevieve);
        if (isRevieve) {
            if (revieveAnalyticsID === 'skincare') {
                setIsSkinCareModal(true);
                setPartnerID(skinCareKey);
                !skinCareUrlEvent &&
                    extractedWord === 'skincare' &&
                    dispatch(triggerSkinCareModal());
                skinCareUrlEvent = true;
            } else if (revieveAnalyticsID === 'vto') {
                setIsVirtualTryOnModal(true);
                !vtoUrlEvent &&
                    ['vto', 'virtual'].includes(extractedWord) &&
                    dispatch(triggerVTOModal());
                vtoUrlEvent = true;
                setPartnerID(nonPdpVirtualTryOnKey);
            } else if (revieveAnalyticsID === 'haircare') {
                setIsHairCareModal(true);
                setPartnerID(hairCareKey);
                !haircareUrlEvent &&
                    extractedWord === 'haircare' &&
                    dispatch(triggerHairCareModal());
                haircareUrlEvent = true;
            }
        }
        setIsIE11(!!window.MSInputMethodContext && !!document.documentMode);
    };

    useEffect(() => {
        if (enableRevieveModal && analyticsId) {
            revieveBannerModal();
            isRevieve && isSrcOpen && addItemInCart();
        }
    }, []);

    /* istanbul ignore next */
    const addItemsToCart = (productList = [], bannerPartnerId) => {
        const { revieveATC } = actions;
        const { revieveConfiguration: { skinCareKey = '', hairCareKey = '' } = {} } = preferences;
        const isSkinCare = bannerPartnerId === skinCareKey;
        const isHairCare = bannerPartnerId === hairCareKey;
        const { cartItemsToAdd, product } = addRevieveItemsToCart(
            productList,
            isSkinCare,
            isHairCare
        );
        cartItemsToAdd &&
            cartItemsToAdd.length > 0 &&
            dispatch(revieveATC({ data: cartItemsToAdd }));
        setAnalyticsPayload(product);
    };

    /* istanbul ignore next */
    const addItemInCart = () => {
        window.removeEventListener(
            'addRevieveItemToCart',
            (e) => {
                e.stopImmediatePropagation();
                addItemsToCart(e.detail?.productList, e.detail?.partnerId);
            },
            true
        );
        window.addEventListener(
            'addRevieveItemToCart',
            (e) => {
                e.stopImmediatePropagation();
                addItemsToCart(e.detail?.productList, e.detail?.partnerId);
            },
            true
        );
    };

    /* istanbul ignore next */
    const onBannerClick = (event) => {
        event?.stopPropagation();
        event?.preventDefault();
        const partnerId = partnerID;
        const { triggerSkinCareModal, triggerVTOModal, triggerHairCareModal } = analyticsActions;
        if (partnerId && (!event.detail || event.detail === 1)) {
            try {
                !isEmpty(analyticsPayload) && setAnalyticsPayload([]);
                window.runRevieveInstance(partnerId, {});
                addItemInCart();
                // this is to track analytics event when skin care model been clicked on
                isSkinCareModal && dispatch(triggerSkinCareModal());
                // this is to track analytics event when virtual try on model been clicked on
                isVirtualTryOnModal && dispatch(triggerVTOModal());
                isHairCareModal && dispatch(triggerHairCareModal());
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Could not load Revieve modal, ', error);
            }
        }
    };

    const bannerImage = (
        <>
            {isRevieveBanner && !isIE11 ? (
                <>
                    <button
                        className={`${'revieve-banner'} ${dt(['w-full'])}`}
                        onClick={(e) => onBannerClick(e)}
                        type="button"
                    >
                        {componentToBeRendered}
                    </button>
                    <RevieveMessageBox analyticsPayload={analyticsPayload} />
                    <div className={dt(['hidden'])}>
                        <Loading />
                    </div>
                </>
            ) : (
                componentToBeRendered
            )}
            <MessageBox
                className={dt(['mt-2'])}
                message={unsupportedBrowserMessage}
                messageType="info"
                showMessage={isIE11}
            />
        </>
    );
    return <div>{bannerImage}</div>;
};

export default RevieveModal;
